/**
 * Created by Andrey Popov on 1/25/23.
 */

const BombOnCardView = cc.Node.extend({
    ctor: function (bombOnCard) {
        this._super();
        this.setAnchorPoint(0.5, 0.5);

        this.bombOnCard = bombOnCard;

        const styles = cleverapps.styles.BombOnCardView;
        this.shown = false;
        this.animation = new cleverapps.Spine(bundles.card.jsons.bomb_json);
        this.animation.setAnimation(0, "bomb_idle", true);
        this.animation.setTimeScale(0);
        this.animation.setAlignment(styles.animation);
        this.addChild(this.animation);

        this.counterText = cleverapps.UI.generateImageText(bombOnCard.counter, cleverapps.styles.FONTS.BOMB_COUNTER_TEXT);
        this.counterText.fitTo(styles.counter.width);
        this.counterText.setAlignment(styles.counter);
        this.counterText.baseScale = this.counterText.getScale();
        this.animation.addChild(this.counterText);

        this.animation.setScale(0);

        this.setCascadeColorEnabled(true);
        this.updateBombVisibility();

        bombOnCard.onChangeCounter = this.createListener(this.onChangeCounterValue.bind(this));
        bombOnCard.onRemove = this.createListener(this.removeFromParent.bind(this));
        bombOnCard.onFlip = this.createListener(this.onFlip.bind(this));
        bombOnCard.onHide = this.createListener(this.hide.bind(this));

        if (cleverapps.environment.isEditorScene()) {
            this.addIncDecBlock();
        }
    },

    show: function () {
        this.shown = true;
        this.animation.setScale(1);
        this.animation.setTimeScale(1);
    },

    hide: function () {
        this.animation.setTimeScale(0);
        this.shown = false;
    },

    updateBombVisibility: function () {
        const visible = this.bombOnCard.isActive() || cleverapps.environment.isSceneWithPreview();
        if (visible && !this.shown) {
            this.show();
        } else if (!visible && this.shown) {
            this.hide();
        }
    },

    onFlip: function () {
        this.runAction(new cc.Sequence(
            new cc.DelayTime(0.3),
            new cc.CallFunc(this.updateBombVisibility.bind(this))
        ));
    },

    onChangeCounterValue: function () {
        const dangerLevel = this.bombOnCard.getDangerLevel();
        this.counterText.runAction(new cc.Spawn(
            StandartAnimations.countTo(this.counterText, this.bombOnCard.counter, {}),
            StandartAnimations.pulse(this.counterText, {}),
            new cc.CallFunc(() => {
                this.animation.setAnimation(0, BombOnCardView.DANGER_ANIMATIONS[dangerLevel], true);
                cleverapps.effects.fire("tile3.bomb.indication");
            }),
            dangerLevel ? new cc.TintTo(0.4, 255, 235, 110) : new cc.TintTo(0.4, 255, 255, 255)
        ));
    },

    addIncDecBlock: function () {
        const incDecBlock = new IncDecBlock({
            value: this.bombOnCard.counter,
            onChange: function (value) {
                this.bombOnCard.counter = value;
                this.onChangeCounterValue();
                Editor.currentEditor.save();
            }.bind(this)
        });
        const cardView = this.bombOnCard.card.onGetView();
        incDecBlock.setPosition(cardView.width / 2, cardView.height / 2);
        incDecBlock.setScale(0.6);
        cardView.addChild(incDecBlock, 5);
    }

});

BombOnCardView.explosion = function () {
    const scene = cleverapps.Scenes.GetRunningScene();
    const yOffset = cleverapps.styles.BombOnCardView.explosion.yOffset;
    const explosion = new cleverapps.Spine(bundles.card.jsons.bomb_explosion_json);
    explosion.setAnimation(0, "explosion", false);
    scene.addChild(explosion);
    explosion.setPosition(scene.width / 2, scene.height / 2 + yOffset);
    explosion.runAction(cleverapps.effects.fireAction("tile3.bomb.explosion"));
    explosion.setCompleteListenerRemove();

    const shakeAction = StandartAnimations.shake(scene, {
        x: scene.width / 2,
        y: scene.height / 2,
        r: 0
    });
    scene.stopAllActions();
    scene.runAction(shakeAction);
};

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    BOMB_COUNTER_TEXT: {
        name: "default",
        size: 35
    }
});

cleverapps.styles.BombOnCardView = {
    animation: {
        x: 85,
        y: 42
    },

    counter: {
        x: { align: "center", dx: 1 },
        y: { align: "center", dy: 0 },
        width: 34
    },

    explosion: {
        yOffset: 120
    }
};

BombOnCardView.DANGER_ANIMATIONS = [
    "bomb_idle",
    "bombcounter_idle",
    "bombcounter_danger"
];